import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'

const BanksForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState('')
  const [logoUrl, setLogoUrl] = useState('')
  const [file, setFile] = useState(null)
  const [logo, setLogo] = useState(null)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        bankName: formData.bankName,
      })
      setImageUrl(formData.bankCover)
      setLogoUrl(formData.bankLogo)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
      setLogoUrl('')
      setFile(null)
      setLogo(null)
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          bankName: values.bankName,
        }
        if (values.logo) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.logo.file)) {
              formImgData.append('image', await compressFile(values.logo.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/heroSelling/bankAccount/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.bankLogo = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.bankLogo = formData.bankLogo
        }
        if (values.cover) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.cover.file)) {
              formImgData.append('image', await compressFile(values.cover.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/heroSelling/bankAccount/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.bankCover = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.bankCover = formData.bankCover
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  async function handleChangeLogo(info) {
    await getBase64(info.file, (logoUrl) => {
      setLogoUrl(logoUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Bank`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="หัวข้อ">
          {getFieldDecorator(`bankName`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อธนาคาร" />)}
        </Form.Item>
        <FormItem label="โลโก้ธนาคาร">
          {getFieldDecorator(`logo`, {
            rules: [
              {
                required: _.isEmpty(formData),
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Upload
            name="logo"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(logo) => beforeUpload(logo)}
            onChange={handleChangeLogo}>
            {logoUrl ? (
              <img src={logoUrl} alt="logo" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
          )}
        </FormItem>
        <FormItem label="ภาพหน้าปก">
          {getFieldDecorator(`cover`, {
            rules: [
              {
                required: _.isEmpty(formData),
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Upload
            name="img"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="img" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
          )}
        </FormItem>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedBanksForm = Form.create({ name: 'BanksForm' })(
  BanksForm
)
export default WrappedBanksForm
